jQuery(function () {
  if (typeof gsap === "undefined") return;

  const slider = document.querySelector(".rotating_slider .circular-track-wrap");
  if (!slider) return;

  const radius = 680;
  const logoWidth = 107;
  const logoHeight = 32;
  const gap = 100;
  const track = slider.querySelector(".circular-track");
  const items = track.querySelectorAll(".logo-item");
  const total = items.length;
  if (!total) return;

  gsap.set(track.querySelectorAll("img"), {
    display: "block",
    width: `${logoWidth}px`,
    height: `${logoHeight}px`,
    objectFit: "contain",
  });
  gsap.set(slider, { position: "relative", height: radius * 2 + logoHeight + 40 });
  gsap.set(track, { position: "absolute", top: "50%", left: "50%", width: 0, height: 0 });

  const rawAngles = [];
  let angle = -Math.PI / 2;
  for (let index = 0; index < total; index += 1) {
    rawAngles.push(angle);
    const footprint = logoWidth * Math.abs(Math.sin(angle)) + logoHeight * Math.abs(Math.cos(angle));
    angle += (footprint + gap) / radius;
  }
  const scale = (2 * Math.PI) / (angle + Math.PI / 2);

  items.forEach((item, index) => {
    const itemAngle = -Math.PI / 2 + (rawAngles[index] + Math.PI / 2) * scale;
    gsap.set(item, {
      position: "absolute",
      xPercent: -50,
      yPercent: -50,
      x: Math.round(radius * Math.cos(itemAngle)),
      y: Math.round(radius * Math.sin(itemAngle)),
    });
  });

  const trackTween = gsap.to(track, { rotation: 360, duration: 144, repeat: -1, ease: "none" });
  const itemTween = gsap.to(items, { rotation: -360, duration: 144, repeat: -1, ease: "none" });
  items.forEach((item) => {
    item.addEventListener("mouseenter", () => { trackTween.pause(); itemTween.pause(); });
    item.addEventListener("mouseleave", () => { trackTween.play(); itemTween.play(); });
  });
});
